import axios from 'axios';
// NOTE: this is for all non admin api calls. Admin calls in src/pages/admin/Dashboard.js still use fetch with the secret header for simplicity, but this can be refactored to use this client as well if desired.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: API_BASE_URL + '/functions/v1',
  headers: {
    'Content-Type': 'application/json',
  }
});

api.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem('access_token')}`;
  return config;
});

// Get conversation by MRN
export const getConversation = async (mrn) => {
  const response = await api.get(`/api/patient-conversations/${mrn}`);
  return response.data;
};

// Send message
export const sendMessage = async (mrn, message) => {
  const response = await api.post('/api/patient-conversations', {
    mrn,
    message,
  });
  return response.data;
};

// Transcribe audio
export const transcribeAudio = async (mrn, storagePath, fileName, audioLength, processingType) => {
  const response = await api.post('/api/patient-conversations/transcribe', {
    storagePath,
    fileName,
    audioLength,
    processingType,
    mrn
  }, 
);
  return response.data;
};

export const healthCheck = async () => {
  const response = await api.get('/api/health');
  return response.data;
};

export default api;